import { Locales, PluralCategory } from '@griply/types';
import { getPluralCategory } from '@griply/utils';

import { getRruleKeywords } from './locale-vocabulary';

export enum RruleUnit {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
}

const PLURAL_KEYS: Record<RruleUnit, string> = {
  [RruleUnit.Day]: 'days',
  [RruleUnit.Week]: 'weeks',
  [RruleUnit.Month]: 'months',
  [RruleUnit.Year]: 'years',
};

const UNIT_FORM_OVERRIDES: Partial<
  Record<Locales, Record<RruleUnit, Partial<Record<PluralCategory, string>>>>
> = {
  [Locales.PlPL]: {
    [RruleUnit.Day]: {
      [PluralCategory.One]: 'dzień',
      [PluralCategory.Few]: 'dni',
      [PluralCategory.Many]: 'dni',
    },
    [RruleUnit.Week]: {
      [PluralCategory.One]: 'tydzień',
      [PluralCategory.Few]: 'tygodnie',
      [PluralCategory.Many]: 'tygodni',
    },
    [RruleUnit.Month]: {
      [PluralCategory.One]: 'miesiąc',
      [PluralCategory.Few]: 'miesiące',
      [PluralCategory.Many]: 'miesięcy',
    },
    [RruleUnit.Year]: {
      [PluralCategory.One]: 'rok',
      [PluralCategory.Few]: 'lata',
      [PluralCategory.Many]: 'lat',
    },
  },
};

export const getUnitForm = (
  unit: RruleUnit,
  count: number,
  language: Locales,
) => {
  const category = getPluralCategory(count, language);
  const override = UNIT_FORM_OVERRIDES[language]?.[unit]?.[category];
  if (override) {
    return override;
  }

  const keywords = getRruleKeywords(language);
  return category === PluralCategory.One
    ? keywords[unit]
    : keywords[PLURAL_KEYS[unit]];
};
